import sendRequest from '../client/sendRequest';

const BASE_URL = '/api/services';

// Add new rate to an existing Services
export async function postServiceRate(serviceId, data) {
  return await sendRequest(`${BASE_URL}/${serviceId}/rates`, 'POST', data);
}

// Edit current rates for an existing Service
export async function editServiceRate(serviceId, rateId, data) {
  return await sendRequest(
    `${BASE_URL}/${serviceId}/rates/${rateId}`,
    'PUT',
    data,
  );
}

// Delete rates for an existing Service
export async function deleteRate(serviceId, rateId) {
  return await sendRequest(
    `${BASE_URL}/${serviceId}/rates/${rateId}`,
    'DELETE',
  );
}
